import GenericCard from "@ui-components/Card/GenericCard";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import React from "react";


interface StatusEntry {
  status: number;
  text: string;
  createdAt: string;
}

interface StatusTableProps {
  data: StatusEntry[];
  headerContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  wrapperClassName?: string;
}

const statusVariantMap: Record<number, "success" | "neutral" | "warning"> = {
  2: "success",  // Finished
  1: "neutral",  // Active
  3: "warning",  // Pending
};

const StatusTable: React.FC<StatusTableProps> = ({
  data,
  headerContent = "Status",
  rightContent = "Date / Hour",
  wrapperClassName = "justify-start", }) => {
  return (
    <div className={`flex ${wrapperClassName} py-4`}>
      <div className='w-full md:w-3/4'>
      <GenericCard
        isCollapsible={true}
        initialExpanded
        headerContent={headerContent}
        rightContent={rightContent}
        bodyContent={
          <>
            {data?.map((entry, itemIndex) => (
              <div key={itemIndex} className="flex justify-between items-center py-2 border-b last:border-0">
                <GenericTag minWidth="90px" label={String(entry.text)} variant={statusVariantMap[entry.status]} />
                <p className=" text-sm text-semantic-text-secondary">
                  {new Date(entry.createdAt).toLocaleString("es-MX", {
                    day:   "2-digit",
                    month: "2-digit",
                    year:  "numeric",
                    hour:   "2-digit",
                    minute: "2-digit",
                    hour12: false,
                    timeZone: "America/Mexico_City",
                    timeZoneName: "short"
                  })}
                </p>
             </div>
            ))}
          </>
        }
      />
      </div>
    </div>
  );
};

export default StatusTable;

